import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import UserTab from './UserTab';
import WorkPositionTab from './WorkPositionTab';



const User = ({company}) => {

    const [activeTab, setActiveTab] = useState('USERS');
    const [t] = useTranslation();

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('header.company.users')}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('header.company.company')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('header.company.users')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'USERS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('USERS')
                                                    }
                                                >
                                                    {t('user.label.users')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'WORK_POSITIONS'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('WORK_POSITIONS')
                                                    }
                                                >
                                                    {t('user.label.workPositions')}
                                                </button>
                                            </li>                                          
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <UserTab
                                                isActive={activeTab === 'USERS'}
                                               
                                            />                                           
                                            <WorkPositionTab
                                                isActive={activeTab === 'WORK_POSITIONS'}
                                                
                                            />                                           
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
                </div>
            </section>
        </>
    );
};

const mapStateToProps = (state) => ({
    company: state.company.currentCompany
 });
 
 export default connect(mapStateToProps,null)(User);